const openMenu = {

    init() {
        window.addEventListener('load', () => {

            const check_btn_open = document.querySelector('#open-btn-menu')
            const openMenuLabel = document.querySelector('#open-menu-label')
            const openMenuLabelSticky = document.querySelector('#open-menu-label-sticky')
            const openMenuLabelClose = document.querySelector('#open-menu-label-close')
            const sideMenuContent = document.querySelector('.side-menu-content')
            
            openMenuLabel.addEventListener('click', () => {
                checkBtnOpen()
            });
        
            openMenuLabelClose.addEventListener('click', () => {
                checkBtnOpen()
            })
        
            openMenuLabelSticky.addEventListener('click', () => {
                checkBtnOpen()
            })
        
            function checkBtnOpen() {
                if(check_btn_open.checked == false) {
                    sideMenuContent.classList.add('active')
                }
                else {
                    sideMenuContent.classList.remove('active')
                }
            }
        
        })
    }
    
}

export default openMenu;